export const SOURCE_VERSION = process.env.REACT_APP_RETAIL_SOURCE_VERSION

export const LATEST_VERSION_URL =
  process.env.REACT_APP_RETAIL_LATEST_VERSION_URL
